<template>
  <div>
    <p
      class="mb-6 mt-6 font-weight-black text-h4"
      v-bind:class="this.textColor"
    >
      利用規約・プライバシーポリシー
    </p>
    <p
      class="ms-12 me-12 mb-6 font-weight-medium text-left"
      v-bind:class="this.textColor"
      style="white-space: pre-wrap; word-wrap: break-word"
    >
      {{ this.ploicy }}
    </p>
  </div>
</template>

<script>
let privacyPolicy = `1.はじめに
マンガ作成アプリ アプリケーション（以下、本アプリ）は、利用者からいくつかの個人データを収集します。 本アプリのご使用によって、本規約に同意していただいたものとみなします。

2.収集する情報
アプリのご利用に際して、本アプリでは、広告配信のためにGoogle AdMob・i-mobile、利用状況解析のためにGoogle Firebase Analytics、クラッシュレポートの取得にFirebase Crashlytics を使用する場合がございます。

広告配信のために広告IDを取得していますが、個人を特定するためなどには使用しておりません。

取得する情報、利用目的、第三者への提供等の詳細につきましては、以下の各サービスのプライバシーポリシー・利用規約のリンクよりご確認ください。

AdMob（Google Inc.）
https://policies.google.com/technologies/ads?hl=ja

i-mobile (株式会社アイモバイル)
https://www.i-mobile.co.jp/privacy.html

FiveAd(LINEヤフー株式会社)
https://line.me/ja/terms/policy/

Firebase Analytics および Firebase Crashlytics （Google Inc.）
https://policies.google.com/privacy?hl=ja
https://marketingplatform.google.com/about/analytics/terms/jp/
https://firebase.google.com/terms/crashlytics/

3 お問い合わせやご意見を頂く際の個人情報の収集
問い合わせで取得したメールアドレス等の情報は、問い合わせへの回答以外では使用しません。
また、問い合わせ内容は、本アプリの品質向上のために利用いたします。

4. 個人情報の第三者への開示・提供の禁止
開発元は、お客さまよりお預かりした個人情報を適切に管理し、次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。
• お客さまの同意がある場合
• 法令に基づき開示することが必要である場合

5. 免責事項
本アプリがユーザーの特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、および不具合が生じないことについて、何ら保証するものではありません。
当方の都合によりアプリの仕様を変更できます。私たちは、本アプリの提供の終了、変更、または利用不能、本アプリの利用によるデータの消失または機械の故障もしくは損傷、その他本アプリに関してユーザーが被った損害につき、賠償する責任を一切負わないものとします。
利用者が本アプリを利用して生じた損害に関して、開発元は責任を負わないものとします。

6. 著作権・知的財産権等
著作権その他一切の権利は、開発元又は権利を有する第三者に帰属します。

7. 連絡先
お問い合わせ先
メール : kan4649kan@gmail.com
twitter : @kkkkan_git




2021年 9月21日 制定
2022年 2月 6日 改訂
2023年 12月 10日 改訂
`
export default {
  name: 'NotFound',
  components: {},
  data() {
    return {
      ploicy: privacyPolicy,
      textColor: String,
    }
  },

  mounted: function () {
    var routeInstance = this.$route
    if (routeInstance.meta.textColorClass) {
      this.textColor = routeInstance.meta.textColorClass
    } else {
      this.textColor = 'black'
    }
  },
}
</script>
